export * from './backlog';
export * from './board';
export * from './report';

export const JOB_FETCH_STARTED = 'JOB_FETCH_STARTED';
export const JOB_FETCH_COMPLETED = 'JOB_FETCH_COMPLETED';
export const JOB_FETCH_FAILED = 'JOB_FETCH_FAILED';
export interface Job {
  jobId: number;
  jobTitle: string;
  jobStatus: number;
  operatorName?: string;
  organizationName?: string;
  divisionName?: string;
  subdivisionName?: string;
  startDate?: string;
  dueDate?: string;
  privateCode?: string;
  locationName?: string;
}
